export class Poly {
  public upperRightCorner: number[];
  public downLeftCorner: number[];
  public zoom: number;
  public center: number[];
}
